import { useTranslation } from 'react-i18next'

import { Alert, Button } from '@vtex/shoreline'

import { useDismissible } from './useDismissible'

export type PlatformNewsAlertProps = {
  storageKey: string
  children: React.ReactNode
  learnMoreHref?: string | null
  learnMoreLabel?: string
  expiryDate?: Date
}

export function PlatformNewsAlert({
  storageKey,
  children,
  learnMoreHref,
  learnMoreLabel,
  expiryDate
}: Readonly<PlatformNewsAlertProps>): JSX.Element | null {
  const { t } = useTranslation()
  const [dismissed, dismiss] = useDismissible(storageKey, expiryDate)

  if (dismissed) return null

  const href = learnMoreHref?.trim() || undefined

  return (
    <div className="mb-2">
      <Alert variant="informational" onDismiss={dismiss}>
        <div className="d-flex align-items-start flex-nowrap gap-3 w-100">
          <span className="flex-grow-1" style={{ minWidth: 0 }}>
            {children}
          </span>
          {href ? (
            <Button variant="tertiary" asChild>
              <a
                className="flex-shrink-0 text-nowrap me-3"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {learnMoreLabel ?? t('rm:alerts.platformNews.learnMore')}
              </a>
            </Button>
          ) : null}
        </div>
      </Alert>
    </div>
  )
}
